import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ManageTooltipService {

  private tooltipJson = {
    deployment: {
      totalSpend: {
        title: "Total usage includes :",
        content: "1. Usage of each HPC node <br />2. Storage price per hour<br />3. VPN cost if activated<br />4. RDMA cost factor if enabled"
      },
      lastUpdate: {
        text: "Time when last billing"
      }
    },
    application: {
      fieldValueTextbox: {
        text: 'Enter default value for the field (Optional)'
      },
      fieldValueDropdown: {
        text: 'Enter comma(,) separated values to be shown in dropdown.'
      },
      fieldValueCheckbox: {
        text: 'If value is true then the checkbox will be checked by default'
      },
      fieldName: {
        text: 'Enter Name for field. <br />for eg: Total Iterations'
      }
    },
    users: {},
    storage: {},
    nodes: {
      nodeGroup: {
        text: 'Nodegroup is state of multiple nodes. A node can be a part of multiple nodegroups.'
      },
      actionTime: {
        text: 'Time when last action was triggered.'
      },
      lastUpdate: {
        text: 'Last accounting time.'
      }
    },
    jobs: {
      nodeGroup: {
        text: 'Nodegroup is state of multiple nodes. A node can be a part of multiple nodegroups.'
      },
      autoShut: {
        text: 'Stops all the nodes after job completion.'
      }
    }
  }

  constructor() { }

  getTooltipOf(module: string, field: string){
    let htmlData;
    
    if(this.tooltipJson[module][field].title){
      htmlData = `
        <div class="card-body text-start" style="padding: 0.5rem!important">
          <h4 class="card-title text-white fs-6 m-0 mb-1">${this.tooltipJson[module][field].title}</h4>
          <p class="card-text" style="font-size: 13px;" *ngFor="">
            ${this.tooltipJson[module][field].content}
          </p>
        </div>
      `
      return htmlData
    }
    
    if(this.tooltipJson[module][field].text){
      htmlData = `
        <p>${this.tooltipJson[module][field].text}</p>
      `
      return htmlData;
    }
  }
}
